import { useEffect } from 'react';

interface MetadataProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  canonicalUrl?: string;
}

export const useMetadata = ({ title, description, keywords, ogImage, canonicalUrl }: MetadataProps) => {
  useEffect(() => {
    // 1. Update Document Title
    if (title) {
      document.title = `${title} | MindfulMe`;
      
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute('content', title);
    } else {
      document.title = 'MindfulMe - Platform Konsultasi Psikolog Online untuk Gen Z Indonesia';
      
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.setAttribute('content', 'MindfulMe - Platform Konsultasi Psikolog Online untuk Gen Z Indonesia');
      }
    }

    // 2. Update Description
    if (description) {
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute('content', description);

      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute('content', description);
    } else {
      const defaultDesc = 'Curhat ke AI Assistant 24/7 atau konsultasi langsung dengan psikolog profesional. Platform kesehatan mental terpercaya untuk Gen Z Indonesia - aman, mudah, dan kapan saja.';
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute('content', defaultDesc);

      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute('content', defaultDesc);
    }

    // 3. Update Keywords
    if (keywords) {
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) metaKeywords.setAttribute('content', keywords);
    } else {
      const defaultKeywords = 'konsultasi psikolog online, kesehatan mental, AI assistant, Gen Z Indonesia, curhat online, psikolog profesional';
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) metaKeywords.setAttribute('content', defaultKeywords);
    }

    // 4. Update OG Image
    if (ogImage) {
      const ogImg = document.querySelector('meta[property="og:image"]');
      if (ogImg) ogImg.setAttribute('content', ogImage);

      const twImg = document.querySelector('meta[name="twitter:image"]');
      if (twImg) twImg.setAttribute('content', ogImage);
    }

    // 5. Update Canonical URL
    if (canonicalUrl) {
      let linkCanonical = document.querySelector('link[rel="canonical"]');
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.setAttribute('rel', 'canonical');
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.setAttribute('href', canonicalUrl);
    }
  }, [title, description, keywords, ogImage, canonicalUrl]);
};
